import { render, staticRenderFns } from "./risk.vue?vue&type=template&id=6fc0e901"
import script from "./risk.vue?vue&type=script&lang=js"
export * from "./risk.vue?vue&type=script&lang=js"
import style0 from "./risk.vue?vue&type=style&index=0&id=6fc0e901&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports